module.exports = __webpack_public_path__ + "img/beian.b2ced505.png";